export default "__VITE_ASSET__DQ1xakKe__"